import { ErrorDataUnavailable } from '../error-data-unavailable';

/** @deprecated Use ErrorDataUnavailable instead. This component be removed in next version update */
export const Error = ErrorDataUnavailable;
